"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Archive Admin API
 * Archive Admin API for managing channels retrieving them from the database. This API allows you to interact with the archived_channels database.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchivedChannelsToJSON =
  exports.ArchivedChannelsFromJSONTyped =
  exports.ArchivedChannelsFromJSON =
    void 0;
var ArchivedChannel_1 = require("./ArchivedChannel");
function ArchivedChannelsFromJSON(json) {
  return ArchivedChannelsFromJSONTyped(json, false);
}
exports.ArchivedChannelsFromJSON = ArchivedChannelsFromJSON;
function ArchivedChannelsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    channels: json["channels"].map(ArchivedChannel_1.ArchivedChannelFromJSON),
  };
}
exports.ArchivedChannelsFromJSONTyped = ArchivedChannelsFromJSONTyped;
function ArchivedChannelsToJSON(value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    channels: value.channels.map(ArchivedChannel_1.ArchivedChannelToJSON),
  };
}
exports.ArchivedChannelsToJSON = ArchivedChannelsToJSON;
